import { format, isValid, parse } from "date-fns";

// Ticket-config fields that are really a date period or a day count, though the config stores
// them as plain "text" (copied from the existing EMS). Recognised by name so no config change is
// needed; proship_mongo's EscalationService validates the same names the same way.
const DATE_RANGE_FIELDS = ["invoiceCycle", "codCycle"];
const DAY_COUNT_FIELDS = ["codCycleDays"];

export const fieldKind = (f) => {
    if (DATE_RANGE_FIELDS.includes(f.name) || f.type === "dateRange") return "dateRange";
    if (DAY_COUNT_FIELDS.includes(f.name) || f.type === "dayCount") return "dayCount";
    return f.type;
};

// The value sent to the backend for a date period: "2026-09-01 to 2026-09-30".
const DATE_FORMAT = "yyyy-MM-dd";
export const DATE_RANGE_PATTERN = /^\d{4}-\d{2}-\d{2} to \d{4}-\d{2}-\d{2}$/;

export const formatDateRange = (startDate, endDate) =>
    startDate && endDate ? `${format(startDate, DATE_FORMAT)} to ${format(endDate, DATE_FORMAT)}` : "";

/** Reverse of formatDateRange, for showing a value already in the form back in the picker. */
export const parseDateRange = (value) => {
    if (!value || !DATE_RANGE_PATTERN.test(value)) return null;
    const [start, end] = value.split(" to ").map((d) => parse(d, DATE_FORMAT, new Date()));
    return isValid(start) && isValid(end) ? { startDate: start, endDate: end } : null;
};
